var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPdf = function SvgPdf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.969 2.5c-1.095 0-2 .906-2 2v5a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2v2c0 1.094.905 2 2 2h12c1.094 0 2-.906 2-2v-13l-5-5zm0 2h8v4h4v1h-12zm-2 7h1.5a1.5 1.5 0 0 1 0 3h-.5v2h-1zm9 0h3v1h-2v1h1.6v1h-1.6v2h-1zm-5 .023h1.628c1.582 0 2.372.952 2.372 2.106v.771c0 1.168-.791 2.1-2.385 2.1H8.969zm-3 .977v1h.5a.5.5 0 0 0 0-1zm4 .023V15.5h.615c.632 0 1.385-.192 1.385-1.1v-.771c0-.914-.746-1.106-1.372-1.106zm-3 5.977h12v2h-12z"
  })));
};
export default SvgPdf;